import apiFetch from '../apiFetch'

export default function (token, dossierSubTypeId) {
  const queryParamsArray = [
    `dossierSubTypeId=${dossierSubTypeId}`
  ]
  const queryParams = queryParamsArray.reduce(
    (result, query, idx) => result + (query ? (result ? `&${query}` : `?${query}`) : '')
    , ''
  )
  return apiFetch({ endPoint: `CampaignDetails/GetByDossierSubTypeId${queryParams}`, method: 'GET', body: null, token: token })
}
